import React from "react";
import { Modal } from "react-bootstrap";
import ContactImg from "assets/images/contactImg.png";
import "./styles.scss";
import Button from "common/components/Button";
import LoginCloseIcon from "assets/images/m-close-login.svg";

interface Props {
  show: boolean;
  onHide?: () => void;
}

const ModalContact = ({ show, onHide }: Props) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      backdrop="static"
      animation={false}
      keyboard={false}
      centered
      className="container-contact-modal">
      <div className="show-modal-desktop">
        <Modal.Body>
          <div className="wrapper-contact-modal">
            <div className="contact-block-top">
              <span className="login-close-icon" onClick={onHide}>
                <img src={LoginCloseIcon} alt="" />
              </span>
              <img src={ContactImg} />
            </div>
            <div className="contact-block-bottom">
              <span style={{ marginBottom: 30 }}>פנייתכם נשלחה בהצלחה ותטופל בקרוב</span>
              <Button
                text="תודה"
                style={{ width: 400, height: 60, padding: 0, background: "rgba(59, 200, 149, 1)" }}
                onClick={onHide}
              />
            </div>
          </div>
        </Modal.Body>
      </div>
      <div className="show-modal-mobile">
        <Modal.Body>
          <div className="wrapper-contact-modal">
            <div className="border-gradient-modal-mobile-contact">
              <div className="contact-block-top">
                <span className="login-close-icon" onClick={onHide}>
                  <img src={LoginCloseIcon} alt="" />
                </span>
                <img src={ContactImg} style={{ width: 148, height: 148 }} />
              </div>
            </div>

            <div className="contact-block-bottom">
              <span style={{ marginBottom: 30, fontSize: 22, textAlign: "center" }}>
                פנייתכם נשלחה בהצלחה ותטופל בקרוב
              </span>
              <Button
                text="בסדר"
                style={{
                  width: "100%",
                  height: 45,
                  padding: 0,
                  background: "rgba(59, 200, 149, 1)"
                }}
                onClick={onHide}
              />
            </div>
          </div>
        </Modal.Body>
      </div>
    </Modal>
  );
};

export default ModalContact;
